import { CipherService } from "./CipherService";

const ACCESS_TOKEN_KEY = "access_token";
const LOGIN_STATUS_KEY = "isUserLoggedIn";
const SESSION_KEYS = [ACCESS_TOKEN_KEY, LOGIN_STATUS_KEY] as const;

let sessionExpiredHandler: (() => Promise<void> | void) | null = null;
let isHandlingSessionExpiry = false;

export const SessionService = {
  async setAccessToken(token: string): Promise<void> {
    await CipherService.set(ACCESS_TOKEN_KEY, token);
  },

  async getAccessToken(): Promise<string> {
    return await CipherService.get(ACCESS_TOKEN_KEY);
  },

  async setLoginStatus(status: boolean): Promise<void> {
    await CipherService.set(LOGIN_STATUS_KEY, status.toString());
  },

  async isLoggedIn(): Promise<boolean> {
    const status = await CipherService.get(LOGIN_STATUS_KEY);
    return status === "true";
  },

  async clearSession(): Promise<void> {
    await Promise.all(SESSION_KEYS.map((key) => CipherService.remove(key)));
  },

  registerSessionExpiredHandler(handler: (() => Promise<void> | void) | null): void {
    sessionExpiredHandler = handler;
  },

  async handleSessionExpired(): Promise<void> {
    if (isHandlingSessionExpiry) {
      return;
    }

    isHandlingSessionExpiry = true;

    try {
      if (sessionExpiredHandler) {
        await sessionExpiredHandler();
        return;
      }

      await SessionService.clearSession();
    } finally {
      isHandlingSessionExpiry = false;
    }
  },
};
